// extracted by mini-css-extract-plugin
export default {"our_team":"OurTeam_our_team__AMaA8"};